import { useMemo } from "react"
import { Config, State, Total, Designation } from "../types"
import { designationTotalCents } from "../utils/designationTotal"
import { calculateFeeCoverage } from "../utils/coverTheFee"

type ConfigForTotalCents = Pick<Config, "fee_rates">
type StateForTotalCents = Pick<
  State,
  "designations" | "stripePaymentMethod" | "feeCovered"
>
export function useCalculatedTotalAndDesignations(
  config: ConfigForTotalCents,
  state: StateForTotalCents,
): { totalCents: Total; calculatedDesignations: Designation[] } {
  const { fee_rates } = config
  const { designations, stripePaymentMethod, feeCovered } = state
  const paymentMethodType = stripePaymentMethod?.type

  return useMemo(
    () =>
      calculateTotalAndDesignations({
        fee_rates,
        designations,
        paymentMethodType,
        feeCovered,
      }),
    [fee_rates, designations, paymentMethodType, feeCovered],
  )
}

interface CalculateTotalAndDesignationsParams {
  fee_rates: Config["fee_rates"]
  designations: State["designations"]
  paymentMethodType?: string
  feeCovered: State["feeCovered"]
}
export function calculateTotalAndDesignations({
  fee_rates,
  designations,
  paymentMethodType,
  feeCovered,
}: CalculateTotalAndDesignationsParams): {
  totalCents: Total
  calculatedDesignations: Designation[]
} {
  let calculatedDesignations = designations
  if (feeCovered) {
    const { designationsCoveringFee } = calculateFeeCoverage(
      { fee_rates },
      designations,
      paymentMethodType,
    )
    calculatedDesignations = designationsCoveringFee
  }
  return {
    totalCents: designationTotalCents(calculatedDesignations),
    calculatedDesignations,
  }
}
